import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const labRegionEditRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/regions/$id/edit',
  params: z.object({ id: zodPathParamId }),
}).lazy(() => import('pages/lab/Regions/LabRegionEditPage/LabRegionEditPage').then((d) => d.Route));
